<script>
import experimentHooks from "../experiment/experimentHooks";

export default {
    name: "SearchResultMultiple",
    data() {
        return {
            content: null,
            isArray: null,
            imagesList: [],
            listWithAudio: []
        }
    },
    created() {
        this.$root.$on('tt-result-received', data => {
            this.content = data
            this.isArray = Array.isArray(data)
            if (this.isArray) {
                this.imagesList = data.filter(item => !item.url.some(file => file.ext === 'mp3'))
                this.listWithAudio = data.filter(item => item.url.some(file => file.ext === 'mp3'))
            }
        });
        this.$root.$on('clear-results', () => {
            this.content = null
        })
    },
    methods: {
        bytesToMB(bytes) {
            return (bytes / (1024 * 1024)).toFixed(2);
        }
    },
}
</script>

<template>
  <section class="multiple" v-if="content && isArray">
    <h3 class="multiple__title">Search Result</h3>
    <div class="multiple__content">
      <div class="multiple__content-cards">
        <div class="multiple__content-item" v-for="image in imagesList" :key="image.id">
          <img
            :src="image.thumb"
            alt=""
            class="multiple__content-image"
          />
          <a :href="image.url[0].url" class="multiple__content-download">
            <img
              src="/img/searchMultiple/download.png"
              alt=""
            />
          </a>
        </div>
      </div>
      <div class="multiple__content-info">
        <p class="multiple__content-author">@{{ content[0].meta.author.nickname }}</p>
        <p class="multiple__content-text">
          {{ content[0].meta.title }}
        </p>
      </div>
    </div>
    <div class="multiple__table">
      <div class="multiple__table-head">
        <div class="multiple__table-column">Quality</div>
        <div class="multiple__table-column">Size</div>
        <div class="multiple__table-column">Download</div>
      </div>
      <div class="multiple__table-content">
        <div v-for="item of listWithAudio" :key="item.id">
          <div class="multiple__table-item" v-for="itemUrl of item.url" :key="itemUrl.url">
            <div class="multiple__table-cell">{{ itemUrl.ext }}</div>
            <div class="multiple__table-cell">-</div>
            <div class="multiple__table-cell">
              <a :href="itemUrl.url" class="multiple__table-btn">Download Audio</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.multiple {
  padding: 0 20px 100px;
  &__title {
    text-align: center;

    font-family: "Roboto", sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    color: #5800b1;
  }

  &__content {
    margin: 40px 0;

    &-cards {
      display: flex;
      justify-content: center;
      gap: 24px;
      flex-wrap: wrap;
      max-width: 1200px;
      margin: auto 0 40px;

      @media (max-width: 1127px) {
        justify-content: center;
      }

      @media (max-width: 992px) {
        justify-content: center;
      }

      @media (max-width: 768px) {
        gap: 16px;
      }
    }

    &-item {
      width: 350px;
      height: 510px;
      position: relative;
      display: inline-block;
      max-width: 100%;
      box-sizing: border-box;

      @media (max-width: 420px) {
        width: 100%;
        max-width: 350px;
        min-height: 510px !important;
        margin: 0 auto;
      }
    }

    &-image {
      width: 100%;
      height: 510px !important;
      overflow: hidden;
      object-fit: cover;
      border-radius: 6px;

      @media (max-width: 420px) {
        height: auto;
      }
    }

    &-download {
      position: absolute;
      right: 12px;
      top: 12px;
      cursor: pointer;

      & img {
        width: 100%;
        max-width: 364px;
        height: auto;
      }
    }

    &-author {
      font-family: "Roboto", sans-serif;
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
      color: #5800b1;
      margin-bottom: 12px;
    }

    &-text {
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      font-size: 18px;
      line-height: 30px;
      color: rgba(63, 63, 63, 0.9);
      width: 100%;
    }
  }

  &__table {
    &-item {
      border: 1px solid rgb(225, 227, 231);
    }

    &-head,
    &-item {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      @media all and (max-width: 450px) {
        grid-template-columns: 70px 70px 1fr;
      }
    }

    &-column {
      width: 100%;
      height: 56px;
      background: rgb(239, 241, 245);
      display: flex;
      align-items: center;
      justify-content: center;
      border-width: 1px 0px 1px 1px;
      border-style: solid;
      border-color: rgb(225, 227, 231);
      font-size: 18px;
      line-height: 1.25;
      color: #5800b1;
      font-family: "Roboto", sans-serif;
      font-weight: 400;
    }

    &-cell {
      width: 100%;
      height: 80px;
      padding: 0 10px;

      display: flex;
      align-items: center;
      justify-content: center;

      font-family: "Roboto", sans-serif;
      font-weight: 400;
      font-size: 18px;
      line-height: 1.25;
      color: #5800b1;
      box-sizing: border-box;

      &:nth-of-type(2) {
        border-right: 1px solid rgb(225, 227, 231);
        border-left: 1px solid rgb(225, 227, 231);
      }

      @media (max-width: 576px) {
        font-size: 16px;
      }
    }

    &-btn {
      outline: none;
      border: none;
      background: var(--color-buttons, #6400c9);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 600;
      line-height: 1.25;
      color: #fff;
      padding: 12px 35px;
      width: 100%;
      text-decoration: none;
      text-align: center;

      @media (max-width: 576px) {
        padding: 10px 15px;
      }
    }
  }
}
</style>
